export interface FlightItemMetadata {
  originCode: string;
  destinationCode: string;
  distance: number;
  cabinClass: 'ECONOMY' | 'PREMIUM_ECONOMY' | 'BUSINESS' | 'FIRST';
  emissions: number;
  passengers: number;
  departureYear: number;
  departureDate?: string;
  flightNumber?: string;
}
